import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/A2.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')